export enum SupportedLocalesEnum {
    DeDe = 'de-DE',
    EnGb = 'en-GB',
    EnUs = 'en-US',
}
